import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** 识别结果横幅属性。 */
export interface ArchiveOcrBannerProps {
    /** 已填充字段数。 */
    total: number;
    /** 批量确认是否仍有效。 */
    armed: boolean;
    /** 确认或撤销高置信项。 */
    onToggle: () => void;
}

/**
 * 展示 OCR 已填充分区说明，并提供确认高置信项 / 撤销。
 * 文案对齐 anagrafica-v4：已填充数量 + 可自动填充分区 + 需人工填写分区。
 * @param props 已填充数量与批量确认状态
 */
export function ArchiveOcrBanner({
    total,
    armed,
    onToggle,
}: ArchiveOcrBannerProps): JSX.Element {
    const { t } = useTranslation();
    return (
        <Box className="archive-ocr-banner">
            <Typography className="archive-ocr-banner__icon" variant="subtitle2" component="span">
                AI
            </Typography>
            <Typography className="archive-ocr-banner__text" variant="body2" component="div">
                <Typography variant="subtitle2" component="span">
                    {t('archive_form_ocr_filled_banner_count', { total })}
                </Typography>
                {t('archive_form_ocr_filled_banner_detail')}
            </Typography>
            <Button className="archive-ocr-banner__action" variant="outlined" size="small" onClick={onToggle}>
                {armed ? t('archive_form_ocr_undo_high') : t('archive_form_ocr_confirm_high')}
            </Button>
        </Box>
    );
}
